import { mdiCheck, mdiTextBox } from '@mdi/js';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import React from 'react';
import useCollectionFollow from '@/hooks/collectionFollowHook';
import { useAuth } from '@/providers/AuthProvider';

const CollectionFollowButton = (props) => {
  const { collection } = props;
  const { isLoggedIn, isVerified, showVerifyEmailDialog } = useAuth();
  const { status, follow, unfollow } = useCollectionFollow(
    collection.author.uid,
    collection.id,
  );

  const clickFollow = () => {
    if (isLoggedIn && isVerified) {
      follow();
    } else {
      showVerifyEmailDialog();
    }
  };

  const clickUnfollow = () => {
    unfollow();
  };

  let className = 'button follow-button is-rounded is-fullwidth is-medium';
  let buttonText = <span>Follow</span>;
  let buttonIcon = mdiTextBox;

  if (status === 'waiting') {
    className = `${className} is-loading`;
  }

  if (status === 'following') {
    className = `${className} is-info`;
    buttonIcon = mdiCheck;
    buttonText = (
      <span className="button-labels">
        <span className="button-label-default">Following</span>
        <span className="button-label-hover">Unfollow</span>
      </span>
    );
  } else {
    className = `${className} is-primary is-outlined`;
  }

  return (
    <div className="follow-buttons">
      <button
        type="button"
        className={className}
        onClick={status === 'following' ? clickUnfollow : clickFollow}
      >
        <span className="icon">
          <Icon path={buttonIcon} size={1} />
        </span>
        {buttonText}
      </button>
    </div>
  );
};

CollectionFollowButton.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default CollectionFollowButton;
